import * as React from 'react';
import { ArticleHeading3, IconChevronRight16, TDeviceType, ArticleParagraph1, UIText2 } from '@cian/ui-kit';
import { clsx } from 'clsx';
import * as styles from './MortgagePrograms.css';
import { IMortgagePrograms } from '../../../types/promosPage/mortgagePrograms';
import { Section } from '../../Section';

interface IMortgageProgramsProps {
  deviceType: TDeviceType;
  mortgagePrograms: IMortgagePrograms[];
}

export const MortgagePrograms: React.FC<IMortgageProgramsProps> = ({ deviceType, mortgagePrograms }) => {
  const isMobile = deviceType === 'tablet' || deviceType === 'phone';
  // istanbul ignore next
  const InfoTitle = isMobile ? ArticleParagraph1 : ArticleHeading3;

  return (
    <Section title="Ипотечные программы">
      <div className={clsx(styles['list'], styles[`list-${deviceType}`])}>
        {mortgagePrograms.map(({ title, description, searchUrl, mobileIconUrl, desktopIconUrl }) => {
          return (
            <a
              className={clsx(styles['item'], styles[`item-${deviceType}`])}
              href={searchUrl}
              key={title}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className={clsx(styles['logo-container'], styles[`logo-container-${deviceType}`])}>
                <img
                  className={styles['logo']}
                  src={isMobile ? /* istanbul ignore next */ mobileIconUrl : desktopIconUrl}
                  alt=""
                />
              </div>
              <div className={styles['content']}>
                <div className={clsx(styles['info'], styles[`info-${deviceType}`])}>
                  <InfoTitle as="h3" color="black_100">
                    {title}
                  </InfoTitle>
                  <UIText2 color="current_color">{description}</UIText2>
                </div>
                {/* istanbul ignore next */}
                {isMobile && <IconChevronRight16 />}
              </div>
            </a>
          );
        })}
      </div>
    </Section>
  );
};
